import { render, staticRenderFns } from "./PatientList.vue?vue&type=template&id=bc55beda"
import script from "./PatientList.vue?vue&type=script&lang=js"
export * from "./PatientList.vue?vue&type=script&lang=js"
import style0 from "./PatientList.vue?vue&type=style&index=0&id=bc55beda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports